/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import GetStartedCta from "./GetStartedCta.container";

export default GetStartedCta;
